export const NO_PERMISSION_REASON = 'In the current workgroup, you do not have permission to install solutions.';

export const NO_AVAILABLE_WORKSPACE_REASON =
  'No workspace is available for a new solution. A solution can only be installed on a running workspace that does not have a solution yet.';

export const INSIGHTS_ADDON_DISABLED_REASON =
  'Insights is not enabled on this workspace. Go to the Add-ons page to enable it.';
